import { useBoolean } from '@insta-club/hooks';
import { Guides, Story } from '@insta-club/models';
import { t } from '@insta-club/translations';
import { BottomSheet, GuideDialog } from '@insta-club/ui';
import { useState } from 'react';
import ProgramCategory from '../program-category';
import StoryProgram from './program';

interface Props {
    story?: Story;
    programID: number;
    dayNumber: number;
    hasChatBot: boolean;
    canPerformTask: boolean;
    date: string;
}

const StoryTask: React.FC<Props> = ({ story, programID, dayNumber, hasChatBot, date, canPerformTask }) => {
    const sheet = useBoolean();
    const [guide, setGuide] = useState<Guides>();

    const openGuide = (guide: Guides) => {
        sheet.onFalse();
        setTimeout(() => {
            setGuide(guide);
        }, 300);
    };

    const closeGuide = () => {
        setGuide(undefined);
        sheet.onTrue();
    };

    return (
        <>
            <ProgramCategory
                title={t('program', t('story'))}
                description={
                    !story || story.is_rest
                        ? 'روز استراحت, امروز استوری جدیدی منتشر نکنید.'
                        : story?.is_done
                          ? 'تکمیل شده'
                          : `شروع از ساعت ${story?.started_at}`
                }
                status={story?.is_done ? 'done' : 'progress'}
                onClick={sheet.onTrue}
                disabled={!story || story.is_rest}
            />
            {story ? (
                <BottomSheet title={`${t('program')} ${t('story')}`} open={sheet.value} onClose={sheet.onFalse}>
                    <StoryProgram
                        hasChatBot={hasChatBot}
                        date={date}
                        onGuide={openGuide}
                        story={story}
                        programID={programID}
                        dayNumber={dayNumber}
                        canPerformTask={canPerformTask}
                    />
                </BottomSheet>
            ) : null}
            <GuideDialog open={guide !== undefined} onClose={closeGuide} guide={guide} />
        </>
    );
};

export default StoryTask;

